<template>
  <div id="app">
    <PlanningPoker/>
  </div>
</template>

<script>
import PlanningPoker from './components/planning-poker.vue'

export default {
  components: { PlanningPoker }
}
</script>

<style lang="scss">
html {
  touch-action: manipulation;
}
html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;

  -webkit-user-select: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
}
body {
  &:after {
    background-image: url(/background-tile.png);
    background-size: 100px 100px;
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    content: " ";
    display: block;
    z-index: -1;
  }
  &.dark {
    background-color: #000;
    &:after {
      background-image: url(/background-tile-dark.png);
    }
  }
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding: env(safe-area-inset-top) env(safe-area-inset-right) env(safe-area-inset-bottom) env(safe-area-inset-left);
}
</style>
